<template>
    <section class="market-dashboard dashboard" ref="fullDashboard">
        <!-- Todo Dashboard está contenido en este div -->

        <div class="dashboard__data right">
            <div class="dashboard__cards">
                <MarketDashboardGeneralFilters
                    :isAdmin="isAdmin"
                    :dashboardTab="dashboardTab"
                    @filterChange="onFilterChange"
                    ref="dashboardGeneralFilters"
                ></MarketDashboardGeneralFilters>
            </div>

            <transition name="fade">
                <CardsDashboard
                    v-show="!showNoData && !isAllLoading"
                    :hideFilters="true"
                    :dashboardTab="dashboardTab"
                    :isAdmin="isAdmin"
                    :generalFilter="generalFilter"
                    filterFor="cards"
                    @cardDashboardNoData="onCardDashboardNoData"
                    ref="cardsDashboard"
                />
            </transition>

            <transition name="fade">
                <BoxPlotChart
                    v-show="!showNoData && !isAllLoading"
                    :graphData="marketGraphDashboardData"
                    :barSize="graphicBarSize"
                    :isLoading="isPriceAndQuantityGraphLoading"
                />
            </transition>
            <transition name="fade">
                <MarketQuantityChart
                    v-show="!showNoData && !isAllLoading"
                    :graphData="marketGraphDashboardData"
                    :barSize="graphicBarSize"
                    :isLoading="isPriceAndQuantityGraphLoading"
                />
            </transition>

            <!-- Si no hay data -->
            <div class="empty-state" v-show="showNoData && !isAllLoading">
                <img
                    alt="No se encontraron datos"
                    src="@/assets/images/empty-dashboard.svg"
                />
                <h2>No se encontaron sufientes datos</h2>
                <p>
                    Lo sentimos, no se encontró información suficiente para
                    mostrar los gráficos con los filtros seleccionados.
                </p>
                <button @click="toggleFilters" id="toggleFilters">
                    Modificar filtros
                </button>
            </div>
        </div>

        <!-- El loading -->
        <div v-show="isAllLoading" class="div-with-loading-container">
            <div
                id="div-with-loading-d"
                class="vs-con-loading__container"
            ></div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import { print } from "graphql";
import BoxPlotChart from "./BoxPlotChart.vue";
import CardsDashboard from "./CardsDashboard.vue";
import ChartMarketDashboard from "./ChartMarketDashboard.vue";
import MarketQuantityChart from "./MarketQuantityChart.vue";
import MarketDashboardGeneralFilters from "./MarketDashboardGeneralFilters.vue";
import marketGraphDashboard from "../../graphql/queries/marketGraphDashboard.gql";

export default {
    name: "market-tab",
    components: {
        CardsDashboard,
        ChartMarketDashboard,
        BoxPlotChart,
        MarketQuantityChart,
        MarketDashboardGeneralFilters,
    },
    props: {
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        isMix: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            selected: "buy",
            marketGraphDashboardData: null,
            graphicBarSize: "5%",
            graphData: null,
            generalFilter: null,
            fastFilterDateInterval: String,
            isPriceAndQuantityGraphLoading: true,
            isCardsDashboardLoading: true,
            showNoData: false,
        };
    },
    mounted() {
        this.$vs.loading({
            container: "#div-with-loading-d",
            scale: 3,
            type: "border",
            color: "#025c98",
            background: "#e8ebed",
        });
    },
    computed: {
        isAllLoading() {
            return (
                this.isPriceAndQuantityGraphLoading ||
                this.isCardsDashboardLoading
            );
        },
    },
    methods: {
        manageFastFilterSelected(optionSelected) {
            this.fastFilterDateInterval = optionSelected;
        },
        onFilterChange(filter) {
            this.generalFilter = {
                weekFrom: filter.invertedWeekFrom,
                weekTo: filter.invertedWeekTo,
                state: filter.filter.state,
                category: filter.filter.category[0]
                    ? filter.filter.category
                    : null,
                type: this.userTypeSelected || filter.filter.type,
                weight: filter.filter.weight,
                invertedWeekFrom: filter.invertedWeekFrom,
                isGlobalFilter: true,
            };
            this.getMarketGraphDashboard();
        },
        filterGlobal() {
            this.$refs.chartMarketDashboard.filterByUser(this.selected);
        },
        onCardDashboardNoData(noData) {
            // NoData determina si hay datos o no en el componente cardDashboard.
            this.showNoData = noData;
            // Si recibió el NoData significa que tambien terminó de cargar la petición, por lo tanto:
            this.isCardsDashboardLoading = false;
        },
        getMarketGraphDashboard() {
            this.isPriceAndQuantityGraphLoading = true;

            // hago esto porque marketGraphDashboard no utiliza esas propiedades.
            let marketFilters = { ...this.generalFilter };
            delete marketFilters.isGlobalFilter;
            delete marketFilters.invertedWeekFrom;

            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(marketGraphDashboard),
                        variables: Object.assign({
                            currentUserToken: localStorage.getItem(
                                "USER_TOKEN"
                            ),
                            filters: marketFilters,
                        }),
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.marketGraphDashboardData = res.data.data;
                        this.isPriceAndQuantityGraphLoading = false;

                        // Con esto se va a definir el largo de las barras de ambas graficas.
                        // Este valor se va a ajustar segun la cantidad de datos que se tengan.
                        // Este valor debe encontrarse definido en porcentaje.
                        let dataLength =
                            res.data.data.marketGraphDashboard.graphValues
                                .length;
                        let size = "5%";

                        switch (true) {
                            case dataLength >= 0 && dataLength < 5:
                                size = "3%";
                                break;
                            case dataLength >= 5 && dataLength < 10:
                                size = "5%";
                                break;

                            case dataLength >= 10 && dataLength < 20:
                                size = "15%";
                                break;

                            case dataLength >= 20 && dataLength < 30:
                                size = "20%";
                                break;

                            case dataLength >= 30:
                                size = "30%";
                                break;
                        }
                        // Si detecto que estan en movile, aumento todo un 5% más.
                        if (
                            this.$refs.fullDashboard &&
                            this.$refs.fullDashboard.clientWidth < 760
                        ) {
                            size = Number(size.split("%")[0]) + 5 + "%";
                        }

                        this.graphicBarSize = size;
                    }
                });
        },
        noAvailableData() {
            return this.$refs.cardsDashboard.noData;
        },
        toggleFilters() {
            this.$refs.dashboardGeneralFilters.$refs.generalFilter.showFilters = true;
        },
    },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
#div-with-loading-d {
    width: 100%;
    height: 300px;
    justify-content: center;
    align-items: center;
    z-index: 0;
    /* position: absolute; */
}
.div-with-loading-container{
    height: 1300px;
    width: 100%;
}
</style>
